// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-dropdown[data-v-07d43c6c] {
  position: relative;
  min-height: 1.8em;
  width: 100%;
  text-align: left;
  outline: none;
  border-bottom: 1px solid var(--asc-item-border-bottom);
  cursor: pointer;
}
.custom-dropdown .placeholder[data-v-07d43c6c] {
  margin-left: 5px;
}
.custom-dropdown.required[data-v-07d43c6c] {
  border-bottom: 1px solid var(--elem-red-color);
  animation: vibra .09s 5 linear;
}
.disabled[data-v-07d43c6c] {
  cursor: initial;
}
.custom-dropdown .selected[data-v-07d43c6c] {
  display: flex;
  align-items: center;
  background-color: var(--bg-color);
  border: none;
  color: var(--font-color);
  padding-left: 0.4em;
  user-select: none;
  padding-bottom: 0.3em;
  height: 100%;
  max-width: 277px;
}
.custom-dropdown .selected span[data-v-07d43c6c] {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding-right: 1.5em;
}
.custom-dropdown .selected span.disabled[data-v-07d43c6c] {
  color: var(--placeholder-color);
}
.custom-dropdown .selected[data-v-07d43c6c]:after {
  position: absolute;
  content: "";
  top: 37%;
  right: 0;
  margin: 0 9px;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-color: var(--placeholder-color) transparent transparent transparent;
}
.custom-dropdown .selected img[data-v-07d43c6c] {
  max-height: 36px;
  padding-right: 12px;
}
.custom-dropdown .items[data-v-07d43c6c] {
  position: absolute;
  line-height: 2em;
  color: var(--font-color);
  background-color: var(--bg-color);
  overflow: hidden;
  margin-top: -1px;
  border: 1px solid var(--asc-item-border-bottom);
  box-shadow: 1px 2px 9px #0000002e, 0px 0px 1px #0000002e;
  left: 0;
  right: 0;
  z-index: 1;
}
.custom-dropdown .items img[data-v-07d43c6c] {
  max-height: 36px;
  padding-right: 12px;
}
.custom-dropdown .items div[data-v-07d43c6c] {
  color: var(--font-color);
  padding-left: 1em;
  cursor: pointer;
  user-select: none;
  padding-right: 1em;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.custom-dropdown .items div[data-v-07d43c6c]:hover {
  background-color: var(--bg-color-hover);
}
.selectHide[data-v-07d43c6c] {
  display: none;
}
.up[data-v-07d43c6c] {
  margin: auto 5px;
  position: absolute;
  transform: translateY(-20px);
  font-size: 0.8em;
  transition-property: all;
  transition-duration: .25s;
}
.nooptions[data-v-07d43c6c] {
  color: var(--font-color);
  padding-left: 0.4em;
  user-select: none;
  padding-right: 0.4em;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/custom/CustomDropDown.vue"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sDAAsD;EACtD,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,8CAA8C;EAC9C,8BAA8B;AAChC;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,QAAQ;EACR,aAAa;EACb,QAAQ;EACR,SAAS;EACT,6BAA6B;EAC7B,0EAA0E;AAC5E;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,+CAA+C;EAC/C,wDAAwD;EACxD,OAAO;EACP,QAAQ;EACR,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":[".custom-dropdown[data-v-07d43c6c] {\n  position: relative;\n  min-height: 1.8em;\n  width: 100%;\n  text-align: left;\n  outline: none;\n  border-bottom: 1px solid var(--asc-item-border-bottom);\n  cursor: pointer;\n}\n.custom-dropdown .placeholder[data-v-07d43c6c] {\n  margin-left: 5px;\n}\n.custom-dropdown.required[data-v-07d43c6c] {\n  border-bottom: 1px solid var(--elem-red-color);\n  animation: vibra .09s 5 linear;\n}\n.disabled[data-v-07d43c6c] {\n  cursor: initial;\n}\n.custom-dropdown .selected[data-v-07d43c6c] {\n  display: flex;\n  align-items: center;\n  background-color: var(--bg-color);\n  border: none;\n  color: var(--font-color);\n  padding-left: 0.4em;\n  user-select: none;\n  padding-bottom: 0.3em;\n  height: 100%;\n  max-width: 277px;\n}\n.custom-dropdown .selected span[data-v-07d43c6c] {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  padding-right: 1.5em;\n}\n.custom-dropdown .selected span.disabled[data-v-07d43c6c] {\n  color: var(--placeholder-color);\n}\n.custom-dropdown .selected[data-v-07d43c6c]:after {\n  position: absolute;\n  content: \"\";\n  top: 37%;\n  right: 0;\n  margin: 0 9px;\n  width: 0;\n  height: 0;\n  border: 5px solid transparent;\n  border-color: var(--placeholder-color) transparent transparent transparent;\n}\n.custom-dropdown .selected img[data-v-07d43c6c] {\n  max-height: 36px;\n  padding-right: 12px;\n}\n.custom-dropdown .items[data-v-07d43c6c] {\n  position: absolute;\n  line-height: 2em;\n  color: var(--font-color);\n  background-color: var(--bg-color);\n  overflow: hidden;\n  margin-top: -1px;\n  border: 1px solid var(--asc-item-border-bottom);\n  box-shadow: 1px 2px 9px #0000002e, 0px 0px 1px #0000002e;\n  left: 0;\n  right: 0;\n  z-index: 1;\n}\n.custom-dropdown .items img[data-v-07d43c6c] {\n  max-height: 36px;\n  padding-right: 12px;\n}\n.custom-dropdown .items div[data-v-07d43c6c] {\n  color: var(--font-color);\n  padding-left: 1em;\n  cursor: pointer;\n  user-select: none;\n  padding-right: 1em;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.custom-dropdown .items div[data-v-07d43c6c]:hover {\n  background-color: var(--bg-color-hover);\n}\n.selectHide[data-v-07d43c6c] {\n  display: none;\n}\n.up[data-v-07d43c6c] {\n  margin: auto 5px;\n  position: absolute;\n  transform: translateY(-20px);\n  font-size: 0.8em;\n  transition-property: all;\n  transition-duration: .25s;\n}\n.nooptions[data-v-07d43c6c] {\n  color: var(--font-color);\n  padding-left: 0.4em;\n  user-select: none;\n  padding-right: 0.4em;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
